import moment from "moment";

export const dateDisplay = (date: any) => {
  if (date) {
    return moment(date).format("YYYY-MM-DD");
  }

  return "";
};
